export function fixNextPageUrl(url?: string | null) {
  const regex = /^http:\/\//;
  if (url != null && regex.test(url)) {
    return url.replace(regex, "https://");
  }
  return url;
}